const courts = require('./courts.json');
const schemaEvr = require ('./schema-evr.json');
const schemaFvio = require ('./schema-fvio.json');

module.exports = {
    courts,
    schemaEvr,
    schemaFvio
};